import classes from './skeleton.module.css'

const Skeleton = {
  classNames: {
    root: classes.root,
  },
}

export default Skeleton
